import { Breadcrumb } from 'antd';
import { Link, useParams } from 'react-router';

import { useGetLMSAccountsDataQuery } from '@/api/endpoints/lmsData';
import { useGetSchoolDataQuery } from '@/api/endpoints/schools';
import { DataSection, FetchDataWrapper, Title } from '@/shared/components';
import { ROUTES } from '@/shared/consts';
import { usePageTitle } from '@/shared/hooks';
import { ESchoolType } from '@/shared/types';

import { ESchoolTypeToText, SCHOOL_TYPE_TO_TEXT_MAPPER } from '../consts';

import styles from './SchoolViewPage.module.scss';
import { ViewCorporateSchoolComponent } from './ViewCorporateSchoolComponent';
import { ViewPublicSchoolComponent } from './ViewPublicSchoolComponent';

const SCHOOL_TYPE_TO_COMPONENT_MAPPER = {
  [ESchoolType.Public]: ViewPublicSchoolComponent,
  [ESchoolType.Corporate]: ViewCorporateSchoolComponent,
};

export const SchoolViewPage = () => {
  usePageTitle('Просмотр школы');

  const { id } = useParams();

  const {
    data: schoolData,
    isLoading: isSchoolDataLoading,
    isError: isSchoolDataFetchError,
  } = useGetSchoolDataQuery({ id: Number(id) });
  const {
    data: lmsAccountsData = [],
    isLoading: areLMSAccountsLoading,
    isError: isFetchLmsAccountsDataError,
  } = useGetLMSAccountsDataQuery();

  return (
    <FetchDataWrapper
      isLoading={isSchoolDataLoading || areLMSAccountsLoading}
      isError={isSchoolDataFetchError || isFetchLmsAccountsDataError}
    >
      {schoolData &&
        lmsAccountsData &&
        (() => {
          const schoolName = schoolData.name;
          const schoolType = schoolData.school_type;
          const lmsAccount = lmsAccountsData.find(({ id }) => id === schoolData.lms_account_id);

          const Component = SCHOOL_TYPE_TO_COMPONENT_MAPPER[schoolType];

          return (
            <div className={styles.wrapper}>
              <Breadcrumb
                items={[
                  { title: 'Публичные страницы' },
                  { title: <Link to={`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}`}>Школы</Link> },
                  { title: schoolName },
                ]}
              />
              <div className={styles['status-wrapper']}>
                <Title>
                  Статус :{' '}
                  <span className={styles['status-published']}>{ESchoolTypeToText.Published.toUpperCase()}</span>
                </Title>
              </div>
              <DataSection titleText="Тип школы">
                <p className={styles['data-value']}>{SCHOOL_TYPE_TO_TEXT_MAPPER[schoolType]}</p>
              </DataSection>
              <Component schoolData={{ ...schoolData, lmsAccountName: lmsAccount ? lmsAccount.name : '' }} />
            </div>
          );
        })()}
    </FetchDataWrapper>
  );
};
